export default __webpack_public_path__ + "static/media/sound.f2d564dd.wav";